<template>
    <div>
        <div style="float: left">
            <el-input placeholder="请输入姓名" v-model="queryParams.keywods" prefix-icon="el-icon-search"
                      style="width: 250px"></el-input>
            <el-button style="margin-left: 10px" type="danger" @click="searchTask">搜索</el-button>
        </div>
        <div style="float: right">
            <el-select :value="queryParams.status" @change="choosestatus($event)">
                <el-option label="全部" value=""></el-option>
                <el-option label="未发送" value="NO"></el-option>
                <el-option label="已发送" value="YES"></el-option>
                <el-option label="发送失败" value="FAIL"></el-option>
            </el-select>
        </div>
        <div class="people-list">
            <el-table class="people-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="peopleList" :row-key="() => Math.random()">
                <el-table-column prop="batchNumber" label="批次号"></el-table-column>
                <el-table-column prop="userName" label="姓名"></el-table-column>
                <el-table-column prop="userEmail" label="邮箱" show-overflow-tooltip></el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.sendStatus)">{{scope.row.sendStatus | formatStatus}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="发送时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.sendTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.createdTime | moment}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
            <div style="text-align: center;margin-top: 50px">
                <el-button type="primary" @click="banckTask">返回</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: 'Detail',
        data() {
            return {
                peopleList: [], //人员列表
                total: 0, //总条数
                queryParams: { //查询参数
                    page: 1,
                    size: 10,
                    status: '',
                    keywods: '',
                    batchNumber: ''
                }
            };
        },
        filters: {
            formatStatus(state) {
                switch (state) {
                    case 0:
                        return "未发送";
                    case 1:
                        return "已发送";
                    case 2:
                        return "发送失败";
                }
            }
        },
        methods: {
            getEmailSendLog(query) {
                api.getEmailSendLog(query).then(({data}) => {
                    this.peopleList = data.list;
                    this.total = data.totalCount;
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getEmailSendLog(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getEmailSendLog(this.queryParams);
            },
            searchTask(){
                this.getEmailSendLog(this.queryParams);
            },
            choosestatus(value){
                this.queryParams.status = value;
                this.getEmailSendLog(this.queryParams);
            },
            banckTask(){
                this.$router.go(-1);
            },
            getStatusClass(state) {
                console.log(state)
                switch (state) {
                    case 0:
                        return "";
                    case 2:
                        return "red";
                    case 1:
                        return "green";
                }
            },

        },
        created() {
            this.queryParams.batchNumber = this.$route.query.batchNum;
            this.getEmailSendLog(this.queryParams);
        }
    };
</script>

<style lang="less" scoped>
    .people-list {
        border: 1px solid #f2ece2;
        clear: both;
        width: 100%;
        .people-table {
            margin-top: 30px;

            .red {
                color: #EC6D56;
            }
            .green {
                color: #6dec82;
            }

        }
    }
</style>
